import { render } from "./Favorite.vue?vue&type=template&id=ccb710a2&scoped=true&ts=true"
import script from "./Favorite.vue?vue&type=script&lang=ts"
export * from "./Favorite.vue?vue&type=script&lang=ts"

import "./Favorite.vue?vue&type=style&index=0&id=ccb710a2&scoped=true&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb710a2"]])

export default __exports__